import { render } from "./HomeRoute.vue?vue&type=template&id=483abd17"
import script from "./HomeRoute.vue?vue&type=script&lang=js"
export * from "./HomeRoute.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__